export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/callbackFrame.4a6752ba.svg","height":139,"width":278,"blurWidth":0,"blurHeight":0};